import { Button, Caption1, Card, Text, CardHeader, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { DismissRegular, LinkRegular } from "@fluentui/react-icons";
import { ISharingLinkCardProps } from "./sharing-link-card.props";
import { getSharingLinkPermissionDisplayText } from "lib/sharing-link-permissions";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";

const layoutStyles = makeStyles({
    mainWrapper: {
        ...shorthands.borderWidth('1px'),
        ...shorthands.borderStyle('solid'),
        ...shorthands.borderColor(tokens.colorNeutralStrokeSubtle),
        ...shorthands.padding('5px'),
        display: 'flex'
    },
    image: {
        width: '28px'
    },
    textWrapper: {
        ...shorthands.overflow('hidden'),
        display: 'inline-grid',
        '> span': {
            display: 'block',
            ...shorthands.overflow('hidden'),
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }
});

export default function SharingLinkCard(props: ISharingLinkCardProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    const onClick = () => {
        console.log(`SharingLinkCard -> onClick -> `, props.item);
        if (props.onSelect)
            props.onSelect(props.item);
    }

    const onDismissClick = () => {
        console.log(`SharingLinkCard -> onDismissClick -> `, props.item);
        if (props.onDismissClick)
            props.onDismissClick(props.item);
    }

    // Format: "{Permission Type} - {Share ID}"
    const permissionDisplay = `${getSharingLinkPermissionDisplayText(props.item.permissionType, t)} - ${props.item.shareId}`;

    return (
        <Card onClick={props.onSelect ? onClick : undefined} appearance={props.style}>
            <CardHeader
                image={<LinkRegular fontSize={28} />}
                header={<div className={styles.textWrapper}><Text as="span">{permissionDisplay}</Text></div>}
                description={<div className={styles.textWrapper}><Caption1 as="span">{props.item.itemName}</Caption1></div>}
                action={props.onDismissClick && <Button onClick={onDismissClick} appearance="subtle" icon={<DismissRegular />} />}
            />
        </Card>
    );
}